import React, { useContext, useEffect } from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import { getPostedByDropdownOptions } from 'api/transformers'
import Fields from 'components/common/Fields'
import { attachRecaptchaScript } from 'utils/recaptchaToken'
import Gender from 'components/fields/registration/Gender'
import Email from 'components/fields/registration/Email'
import Password from 'components/fields/registration/Password'
import PostedBy from 'components/fields/registration/PostedBy'

import { FormDataContext } from 'providers/FormData'

const SetupAccount = props => {
  useEffect(() => attachRecaptchaScript(), [])

  const { formData, loading } = useContext(FormDataContext)

  const postedbyOptions =
    !loading && getPostedByDropdownOptions(formData.postedBy)

  return (
    <>
      <h2 className={formStyles.formTitle}>
        Let's set up your account, while
        <br />
        we find Matches for you!
      </h2>
      <div className="form-row">
        <Email />
        <Password />

        <Field name="postedby">
          {fieldProps =>
            loading ? (
              'loading...'
            ) : (
              <PostedBy options={postedbyOptions} {...fieldProps} />
            )
          }
        </Field>

        <Fields names={['postedby']}>{Gender}</Fields>
      </div>
    </>
  )
}

export default SetupAccount
